@if (missingFacet$ | async) {
<h-grid-page-banner (closeBannerFacet)="closeBannerFacet()"></h-grid-page-banner>
} @if ((isGridFilterRevampEnabled$ | async) === false) { @if (isSearchGrid$ | async) {
<h-grid-result-search-header></h-grid-result-search-header>
} @if ((isSearchGrid$ | async) === false) {
<h-grid-header [resultGridHeader]="resultGridHeader$ | async"></h-grid-header>
} } @if (displayNoResult && (isSearchGrid$ | async) === false) {
<h-grid-no-result>
    <ng-container i18n="@@hermes-global-translations.product_grid_msg_no_results_notification_description">
        Sorry, we currently do not have any item that match your search.
    </ng-container>
</h-grid-no-result>
}
<ng-container>
    @if (isGridFilterRevampEnabled$ | async) { @if (facetSEOLinks && facetSEOLinks.length > 0) {
    <h-seo-links [seoLinks]="facetSEOLinks"></h-seo-links>
    } @if (!displayNoResult) {
    <h-grid-filter-bar></h-grid-filter-bar>
    } } @else { @if (!isSuggestionGrid) {
    <div #gridFilterBarContainer>
        <h-grid-filters-bar></h-grid-filters-bar>
    </div>
    } }
</ng-container>
@if (isGridHighlightsEnabledSignal()) {
<h-grid-highlight></h-grid-highlight>
}
<span
    hSrOnlyNoSnippet
    [attr.data-testid]="'grid-product-list'"
    [attr.role]="'heading'"
    aria-level="2"
    i18n="@@hermes.accessibility.product-grid-product-list">
    Product list
</span>

<div class="grid-result">
    <h-grid-results [isSearchGrid]="isSearchGrid$ | async"> </h-grid-results>
</div>

@if ((isGridSeoPaginationEnabled$ | async) && pagesRoutes?.length) {
<h-seo-pagination-links [links]="pagesRoutes"> </h-seo-pagination-links>
}

<h-livechat [pageType]="pageType$ | async" [position]="'low'"></h-livechat>
